import Vue from 'vue'
import { decode, formatPrice } from 'utils/general'
import { mapState, mapActions } from 'vuex'
import { i18n } from 'lib/i18n.js'
import brandTagDisplay from 'mixins/brand-tag'
import { buildDeliveryMessage, resolveDeliveryCountry, setDeliveryCountry } from 'utils/delivery'

Vue.component('product-form', resolve => {
  Promise.all([
  ]).then(() => resolve({
    mixins: [brandTagDisplay],
    props: ['productJson', 'variants', 'parse', 'deliveryJson'],
    data () {
      return {
        activeOption: '',
        stockValue: 'madeOrder',
        deliveryHtml: '',
        stockStatus: '',
        stockInventory: '',
        outofstockStatus: '',
        activeCountryStatus: '',
        deliveryManufactureTime: 0,
        selectedCountry: '',
        inventryManagement: '',
        deliveryMessageStatus: false,
        options: [
          false,
          false,
          false
        ]
      }
    },
    computed: {
      ...mapState('product', [
        'product',
        'activeVariant',
        'engravingText'
      ]),
      productObject () {
        return this.parse ? JSON.parse(decode(this.productJson)) : this.productJson
      },
      deliveryObject () {
        const deliveryOpt = JSON.parse(decode(this.deliveryJson))
        return deliveryOpt
      },
      activeVariantPrice () {
        if (!this.activeVariant) {
          return false
        }
        if (this.activeVariant.compare_at_price) {
          return formatPrice(this.activeVariant.compare_at_price)
        }
        return formatPrice(this.activeVariant.price)
      },
      activeVariantDiscountPrice () {
        if (!this.activeVariant || !this.activeVariant.compare_at_price) {
          return false
        }
        return formatPrice(this.activeVariant.price)
      },
      engravingItem () {
        return __GLOBAL__.engravingItem.id
      }
    },
    mounted () {
      this.initialOptions()
      this.initDeliveryTime()
    },
    methods: {
      ...mapActions('global', [
        'openModal'
      ]),
      ...mapActions('cart', [
        'addToCart',
        'openCart'
      ]),
      ...mapActions('product', [
        'updateProduct',
        'setActiveVariant',
        'setEngraving'
      ]),
      initialOptions () {
        this.options = [this.activeVariant.option1, this.activeVariant.option2, this.activeVariant.option3]
      },
      initDeliveryTime () {
        const deliveryOpt = this.deliveryObject
        this.stockStatus = this.activeVariant.policy
        this.stockInventory = this.activeVariant.inventory_quantity
        this.outofstockStatus = this.activeVariant.inventory_quantity
        this.inventryManagement = this.activeVariant.management
        this.deliveryManufactureTime = deliveryOpt.manufactureTime

        this.activeCountryStatus = resolveDeliveryCountry(deliveryOpt)
        this.selectedCountry = this.activeCountryStatus
        this.updateDeliveryTime()
      },
      async addProduct () {
        const id = this.activeVariant.id
        const properties = {}

        if (this.engravingText && this.engravingItem) {
          properties['Text'] = this.engravingText
          properties['_key'] = Date.now()
        }
        await this.addToCart({
          id,
          quantity: 1,
          properties,
          withProperties: true
        })

        if (this.engravingText && this.engravingItem) {
          await this.addToCart({
            id: this.engravingItem,
            quantity: 1,
            properties,
            withProperties: true
          })

          this.setEngraving('')
        }
      },
      getIndexByKey (keyValue) {
        let index = 1
        Object.keys(this.product.optionsWithValues).forEach((key, i) => {
          if (key === keyValue) {
            index = i
          }
        })

        return index
      },
      setOption (option, key) {
        this.options[this.getIndexByKey(key)] = option
        this.updateVariant()
      },
      onChange (event) {
        const key = event.target.options[event.target.options.selectedIndex].dataset.key
        const option = event.target.value
        this.options[this.getIndexByKey(key)] = option
        this.updateVariant()
      },
      updateVariant () {
        const filterEmptyValues = this.options.filter(x => x !== 'false')
        const variantTitle = filterEmptyValues.join(' / ')
        const variant = this.product.variants.find(variant => {
          return variant.title === variantTitle
        })

        if (variant) {
          this.setActiveVariant(variant)
          this.updateDeliveryMessage(variant)
        }
      },
      updateDeliveryMessage (variant) {
        this.stockStatus = variant.policy
        this.stockInventory = variant.inventory_quantity
        this.outofstockStatus = variant.inventory_quantity
        this.inventryManagement = this.activeVariant.management

        this.updateDeliveryTime()
      },
      onChangeCountry (event) {
        this.activeCountryStatus = event.target.value
        setDeliveryCountry(this.activeCountryStatus)
        this.updateDeliveryTime()
      },
      updateDeliveryTime () {
        const message = buildDeliveryMessage(
          this.deliveryObject,
          {
            inventory: this.stockInventory,
            policy: this.stockStatus,
            management: this.inventryManagement
          },
          this.activeCountryStatus
        )

        this.deliveryHtml = message.deliveryHtml
        this.stockValue = message.stockValue
        this.deliveryMessageStatus = message.deliveryMessageStatus
      },
      isSizeOption (key) {
        return (key.toLowerCase() === 'size')
      }
    },
    i18n
  }))
})
